import React, { useEffect, useState } from 'react';
import { Box, HStack, Text, Input, Button } from '@chakra-ui/react';
import { CategoryType } from '../Table/MaintenanceCategoryTable';
import { QueryCategoryApi } from '../../../../apis/QueryMaintenance.api';
import { CategorySearchCondition } from '../../../../pages/CategoryMaintenance';
import { CategorySendMessageType } from '../../../constants/MaintenanceConstants';

interface props {
  setMaintenanceDatas: React.Dispatch<
    React.SetStateAction<CategoryType[] | undefined>
  >;
  Query: CategorySearchCondition;
  setQuery: React.Dispatch<React.SetStateAction<CategorySearchCondition>>;
  createOrUpdate: boolean;
  SearchStateSwitch: () => void;
}
const CategorySearchBox: React.FC<props> = (props) => {
  const {
    setMaintenanceDatas,
    Query,
    setQuery,
    createOrUpdate,
    SearchStateSwitch
  } = props;

  const [categoryName, setCategoryName] = useState('');
  // const [type, setType] = useState('');
  const [dateCreatedFrom, setDateCreatedFrom] = useState('');
  const [dateCreatedTo, setDateCreatedTo] = useState('');
  const [dateUpdatedFrom, setDateUpdatedFrom] = useState('');
  const [dateUpdatedTo, setDateUpdatedTo] = useState('');

  useEffect(() => {
    setCategoryName('');
    setDateCreatedFrom('');
    setDateCreatedTo('');
    setDateUpdatedFrom('');
    setDateUpdatedTo('');
  }, [createOrUpdate]);

  const SerachGetApi = async () => {
    const params = new URLSearchParams();
    Query.sort.key !== '' &&
      params.append(
        'order',
        Query.sort.key + (Query.sort.sortType ? '_asc' : '_desc')
      );
    categoryName !== '' && params.append('name_contains', categoryName);
    Query.type !== CategorySendMessageType.None &&
      params.append('type', Query.type);
    dateCreatedFrom !== '' && params.append('created_at_gte', dateCreatedFrom);
    dateCreatedTo !== '' && params.append('created_at_lt', dateCreatedTo);
    dateUpdatedFrom !== '' && params.append('updated_at_gte', dateUpdatedFrom);
    dateUpdatedTo !== '' && params.append('updated_at_lt', dateUpdatedTo);
    const apiQuery = '/?' + params.toString();

    setQuery((pre) => ({
      ...pre,
      categoryName: categoryName,
      dateCreatedFrom: dateCreatedFrom,
      dateCreatedTo: dateCreatedTo,
      dateUpdatedFrom: dateUpdatedFrom,
      dateUpdatedTo: dateUpdatedTo
    }));

    const response = await QueryCategoryApi(apiQuery);
    if (response.success) {
      setMaintenanceDatas(response.data as CategoryType[]);
      SearchStateSwitch();
    }
  };

  return (
    <>
      <Box
        border='1px'
        borderColor='gray'
        ml={14}
        gridRow='2/3'
        gridColumn='2/2'
        w='80%'
        h='260px'
        bgColor='#f4f4f4'
        fontSize={14}
      >
        <Box fontSize={18} bgColor='#e5e6e7'>
          <Text>検索条件</Text>
        </Box>
        <Box w='90%'>
          <Text ml={2} mt={1}>
            カテゴリ名で絞り込む
          </Text>
          <Input
            h='8'
            ml={2}
            bgColor='white'
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
          ></Input>
          {/*<Text ml={2} mt={1}>
            タイプで絞り込む
          </Text>
          */}
          {/*<Select
            h='8'
            ml={2}
            bgColor='white'
            onChange={(e) => setType(e.target.value)}
          >
            <option value={SendMessageType.None}></option>
            <option value={SendMessageType.Signage}>停留場メッセージ</option>
            <option value={SendMessageType.Obc}>OBCメッセージ</option>
            <option value={SendMessageType.Location}>位置情報メッセージ</option>
            <option value={SendMessageType.Message}>共通メッセージ</option>
          </Select>*/}
          <Text ml={2} mt={1}>
            登録日時
          </Text>
          <HStack>
            <Input
              ml={2}
              bgColor='white'
              type='date'
              size='sm'
              value={dateCreatedFrom}
              onChange={(e) => setDateCreatedFrom(e.target.value)}
            />
            <Text>～</Text>
            <Input
              ml={2}
              bgColor='white'
              type='date'
              size='sm'
              value={dateCreatedTo}
              onChange={(e) => setDateCreatedTo(e.target.value)}
            />
          </HStack>
          <Text ml={2} mt={1}>
            更新日時
          </Text>
          <HStack>
            <Input
              ml={2}
              bgColor='white'
              type='date'
              size='sm'
              value={dateUpdatedFrom}
              onChange={(e) => setDateUpdatedFrom(e.target.value)}
            />
            <Text>～</Text>
            <Input
              ml={2}
              bgColor='white'
              type='date'
              size='sm'
              value={dateUpdatedTo}
              onChange={(e) => setDateUpdatedTo(e.target.value)}
            />
          </HStack>
          <Button
            ml={2}
            mt={2}
            bgColor='gray.800'
            color='white'
            onClick={() => SerachGetApi()}
          >
            絞り込む
          </Button>
        </Box>
      </Box>
    </>
  );
};
export default React.memo(CategorySearchBox);
